/** 横屏时的左右间距占比 */
export const X_SPACING = 0.05;
/** 竖屏时的上下间距占比 */
export const Y_SPACING = 0.04;
